import get from "lodash/get";
import { audioBlockTypes } from "../../../constants/audio_management";

const grid = 12;

export const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid,
  margin: `0 0 ${grid}px 0`,
  boxShadow: "0px 2px 16px rgba(0, 0, 0, 0.08)",
  background: "white",
  height: "48px",
  borderRadius: 4,
  fontSize: 15,
  display: "flex",
  overflow: "hidden",
  width: "100%",

  // styles we need to apply on draggables
  ...{
    ...draggableStyle,
    left: `calc(${draggableStyle.left}px - 5.5% )`,
    top: `calc(${draggableStyle.top}px - 5% )`,
  },
});

export const AudioTypes = {
  ad: {
    display: "Automatic RedCircle Ad ",
    secondaryDisplay: "(when Available)",
    type: "ad",
    hideNew: true,
  },
  audioFile: {
    display: "Audio File",
    type: "audioFile",
    showUploader: true,
  },
  crossPromo: {
    display: "Cross Promotion",
    type: "crossPromo",
    toolTipText: "Insert cross promotion only if available",
  },
};
export const NewAudioTypes = Object.keys(AudioTypes)
  .filter(key => !AudioTypes[key].hideNew)
  .map(key => AudioTypes[key]);

export const isDefaultAudioBlock = audioBlock => {
  return (
    get(audioBlock, "type") === audioBlockTypes.defaultCrossPromo ||
    get(audioBlock, "type") === audioBlockTypes.defaultAd
  );
};
